/** The only role that is subject to fine-grained permission checks. */
export const SUB_ACCOUNT_ROLE = 'AD_AGENCY_SUB_ACCOUNT';
